// Helper function to get CSRF token from meta tags
export const getCsrfToken = () => {
  const token = document
    .querySelector("meta[name='csrf-token']")
    ?.getAttribute("content");
  if (!token) {
    console.error("CSRF token not found");
  }
  return token;
};
